import React, { useState, useEffect } from 'react';
import { Button as ButtonCore, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import colors from '../../utils/colors';

const useStyles = makeStyles((theme) => ({
    root: {
        textTransform: 'none', 
        paddingLeft: '40px', 
        paddingRight: '40px', 
        borderRadius: '8px',
        fontWeight: 'normal'
    }
}));

const Button = props => {

    const classes = useStyles();

    const [backgroundColor, setBackgroundColor] = useState(colors?.primary)
    const [color, setColor] = useState('#FFF')
    const [border, setBorder] = useState('none')

    const config = () => {

        if(props.variant == 'contained'){
            if(props.color == 'primary'){
                setBackgroundColor(colors?.primary)
            }else if(props.color == 'warning'){
                setBackgroundColor(colors?.warning)
            }else if(props.color == 'error'){
                setBackgroundColor(colors?.error)
            }else if(props.color == 'light'){
                setBackgroundColor(colors?.light)
                setColor(colors?.primary)
            }else{
                setBackgroundColor(colors?.primary)
            }
            if(props.color != 'light'){
                setColor(colors?.light)
            }
        }else if(props.variant == 'outlined'){
            if(props.color == 'primary'){
                setColor(colors?.primary)
                setBorder(`1px solid ${colors?.primary}`)
            }else if(props.color == 'warning'){
                setColor(colors?.warning)
                setBorder(`1px solid ${colors?.warning}`)
            }else if(props.color == 'error'){
                setColor(colors?.error)
                setBorder(`1px solid ${colors?.error}`)
            }else if(props.color == 'light'){
                setColor(colors?.primary)
                setBorder('')
            }else{
                setColor(colors?.primary)
                setBorder(`1px solid ${colors?.primary}`)
            }
            setBackgroundColor(colors?.light)
        }

    }

    useEffect(() => {
        config()
    }, [0])

    useEffect(() => {

        if(props?.disabled === true || props?.isLoading === true){
            setBackgroundColor('#D7D7D7')
            setColor('gray')
            setBorder('')
        }else{
            config()
        }

    }, [props?.disabled, props?.isLoading])

    return (
        <>

            <ButtonCore 
                fullWidth={props.fullWidth ? true : false}
                className={classes.root}
                style={{ 
                    backgroundColor: backgroundColor,
                    border: border,
                    color: color,
                    height: props.size == 'small' ? '40px' : '50px',
                    ...props.style
                }}
                size={props.size ? props.size : "large"}
                disabled={(props.disabled || props?.isLoading) && true}
                onClick={(event) => {
                    if(props.onClick){
                        props.onClick(event)
                    }
                }}
            >
                {props?.isLoading ?
                    <CircularProgress size={20} sx={{ color: '#FFF' }} />
                :
                    props.label
                }
            </ButtonCore>
            
        </>
    );
}

export default Button;